export * from './home2.component';